module.exports = __webpack_public_path__ + "static/media/plus.359a112f.svg";